import React, { useState, useRef, useEffect } from "react";
import ReactDOM from "react-dom";
import endpointManagerIcon from "./icons/endpoint manager.svg";
import assetManagerIcon from "./icons/inventory.svg";
import remoteAccessIcon from "./icons/Remote Access.svg";
import remoteSupportIcon from "./icons/Reomte Support.svg";
import patchIcon from "./icons/patch.svg"
import vulnerabilityManagerIcon from "./icons/vulnerabilityManager.svg";
import freeTools from "./icons/free tools.svg";
import main from "./icons/main.svg";
import styles from "./ProductSwitch.module.css";
import apps from "./icons/apps.svg";
import { PRODUCT_CONTEXT } from "common-ui-components/components/utils/Config";
import { getCurrentlyRederedModule } from "App";
import { PRODUCT_CONFIG } from "ProductConfig";
import {
  getCurrentlyRederedSettingsSubModule,
  getProductBySettingsSubModuleKey,
} from "app/settings/base/SettingsPage";

// the new products should be added to the PRODUCTS array with the following structure Don't change andy
const PRODUCTS = [
  {
    section: "IT Management",
    key: "em",
    name: "Endpoint Manager",
    description: "Endpoint Management Software",
    icon: endpointManagerIcon,
    iconBg: "#E7ECF9",
    url: "/em/app/home",
  },
  {
    section: "IT Management",
    key: "vm",
    name: "Vulnerability Manager",
    description: "Vulnerability Management Software",
    icon: vulnerabilityManagerIcon,
    iconBg: "#F7F1E6",
    url: "/vm/app/secure",
    isNew: true,
  },
  {
    section: "IT Management",
    key: "pm",
    name: "Patch Manager",
    description: "Patch Management Software",
    icon: patchIcon,
    iconBg: "#E3F4F9",
    url: "/pm/app/secure",
    isNew: true,
  },
  {
    section: "IT Management",
    key: "am",
    name: "Asset Manager",
    description: "IT Asset Management Software",
    icon: assetManagerIcon,
    iconBg: "#E8F4ED",
    url: "/am/app/home",
  },
  {
    section: "IT Management",
    key: "ra",
    name: "Remote Access",
    description: "Unattended Remote Access Software",
    icon: remoteAccessIcon,
    iconBg: "#ECEEFA",
    url: "/ra/app/tools",
  },
  // {
  //   section: "IT & Customer Support",
  //   key: "rs",
  //   name: "Remote Support",
  //   description: "Remote Support Software",
  //   icon: remoteSupportIcon,
  //   iconBg: "#F7F1E6",
  //   url: null,
  // },
  {
    section: "Free Tools",
    key: "ft",
    name: "Zecurit Free Tools",
    description: "IT Management & Security Tools",
    icon: freeTools,
    iconBg: "#F7F1E6",
    url: "https://zecurit.com/tools/",
    openInNewTab: true,
  },
];

const ProductSwitch = () => {
  const [open, setOpen] = useState(false);
  const [renderPanel, setRenderPanel] = useState(false);

  const wrapperRef = useRef(null);
  const dropdownRef = useRef(null);
  const closeTimerRef = useRef(null);

  const openPanel = () => {
    if (closeTimerRef.current) {
      window.clearTimeout(closeTimerRef.current);
      closeTimerRef.current = null;
    }
    setRenderPanel(true);
    window.requestAnimationFrame(() => {
      setOpen(true);
    });
  };

  const closePanel = () => {
    setOpen(false);
    if (closeTimerRef.current) {
      window.clearTimeout(closeTimerRef.current);
    }
    closeTimerRef.current = window.setTimeout(() => {
      setRenderPanel(false);
      closeTimerRef.current = null;
    }, 240);
  };

  // Outside click handler (Portal-safe)
  useEffect(() => {
    const handleClickOutside = (e) => {
      const clickedOutsideWrapper =
        wrapperRef.current && !wrapperRef.current.contains(e.target);

      const clickedOutsideDropdown =
        dropdownRef.current && !dropdownRef.current.contains(e.target);

      if (renderPanel && clickedOutsideWrapper && clickedOutsideDropdown) {
        closePanel();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [renderPanel]);

  useEffect(() => {
    if (renderPanel) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    return () => {
      document.body.style.overflow = "";
    };
  }, [renderPanel]);

  useEffect(() => {
    const handleEsc = (event) => {
      if (event.key === "Escape" && renderPanel) {
        closePanel();
      }
    };

    document.addEventListener("keydown", handleEsc);
    return () => document.removeEventListener("keydown", handleEsc);
  }, [renderPanel]);

  useEffect(
    () => () => {
      if (closeTimerRef.current) {
        window.clearTimeout(closeTimerRef.current);
      }
    },
    [],
  );

  // Toggle dropdown
  const handleToggle = () => {
    if (renderPanel) {
      closePanel();
      return;
    }
    openPanel();
  };

  const sustainRoute = (product) => {
    const path = window.location.pathname;
    const parts = path.split("/");
    const result = `/${product.key}/${parts.slice(2).join("/")}`;
    window.location.href = result;
    closePanel();
  };

  const handleRedirect = (product) => {
    if (!product.url) {
      closePanel();
      return;
    }

    if (PRODUCT_CONTEXT === product.key) {
      closePanel();
      return;
    }

    for (let index = sessionStorage.length - 1; index >= 0; index -= 1) {
      const key = sessionStorage.key(index);
      if (key?.startsWith("upgradePromptLastShownAt_")) {
        sessionStorage.removeItem(key);
      }
    }

    if (product.openInNewTab) {
      window.open(product.url, "_blank", "noopener,noreferrer");
      closePanel();
      return;
    }

    const currentModule = getCurrentlyRederedModule();
    if (currentModule === "SETTINGS") {
      const currentSubModule = getCurrentlyRederedSettingsSubModule();
      console.log("currentSubModule:", currentSubModule);
      const products = getProductBySettingsSubModuleKey(currentSubModule);
      if (!products) {
        sustainRoute(product);
        return;
      }
      if (products.includes(product.key)) {
        sustainRoute(product);
        return;
      }
    } else {
      if (PRODUCT_CONFIG[product.key].routeGroups.includes(currentModule)) {
        sustainRoute(product);
        return;
      }
    }
    window.location.href = product.url;
  };

  const sections = PRODUCTS.reduce((acc, product) => {
    if (!acc[product.section]) {
      acc[product.section] = [];
    }
    acc[product.section].push(product);
    return acc;
  }, {});

  return (
    <div className={styles.wrapper} ref={wrapperRef}>
      <button
        type="button"
        className={`${styles.trigger} ${renderPanel ? styles.triggerActive : ""}`}
        onClick={handleToggle}
        aria-expanded={renderPanel}
        aria-label="Products "
        title="Products"
      >
        <img
          src={apps}
          alt=""
          height={22}
          width={22}
          className={styles.icon}
          aria-hidden="true"
        />
      </button>

      {renderPanel &&
        ReactDOM.createPortal(
          <>
            <div
              className={`${styles.backdrop} ${open ? styles.backdropVisible : ""}`}
              onClick={closePanel}
            />
            <div
              ref={dropdownRef}
              className={`${styles.panel} ${open ? styles.panelOpen : styles.panelClosing}`}
              role="dialog"
              aria-modal="true"
              aria-label="All products"
            >
              <div className={styles.panelHeader}>
                <h3 className={styles.title}>All Zecurit Apps</h3>
                <div className={styles.panelActions}>
                  <button
                    type="button"
                    className={`${styles.iconButton} ${styles.closeButton}`}
                    onClick={closePanel}
                    aria-label="Close product switcher"
                  >
                    <svg viewBox="0 0 20 20" aria-hidden="true">
                      <path d="M5 5l10 10M15 5L5 15" />
                    </svg>
                  </button>
                </div>
              </div>

              {Object.entries(sections).map(
                ([sectionTitle, sectionProducts]) => (
                  <section key={sectionTitle} className={styles.section}>
                    <p className={styles.sectionTitle}>{sectionTitle}</p>
                    {sectionProducts.map((p) => (
                      <button
                        key={p.key}
                        type="button"
                        className={styles.item}
                        onClick={() => handleRedirect(p)}
                      >
                        <div
                          className={styles.productIcon}
                          style={{ backgroundColor: p.iconBg }}
                        >
                          <img src={p.icon} alt="" className={styles.iconSvg} />
                        </div>

                        <div className={styles.productText}>
                          <span className={styles.productNameRow}>
                            <span className={styles.productName}>{p.name}</span>
                            {p.isNew && (
                              <span className={styles.newBadge}>New</span>
                            )}
                          </span>
                          <span className={styles.productDescription}>
                            {p.description}
                          </span>
                        </div>
                        <svg
                          className={styles.chevron}
                          viewBox="0 0 24 24"
                          aria-hidden="true"
                        >
                          <path d="M9 5l7 7-7 7" />
                        </svg>
                      </button>
                    ))}
                  </section>
                ),
              )}
            </div>
          </>,
          document.body,
        )}
    </div>
  );
};

export default ProductSwitch;
